import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";
import Laser from "./laser";
import ProspectsAndCustomers from "./prospectsAndCustomers";
import LeadStatus from "./leadStatus";
import LeadActivity from "./leadActivity";
import AIAgent from "../ai";

const pageConfig = {
  pageName: "Sales Activity",
  configuratorWidth: 375,
  moduleList: [Laser, ProspectsAndCustomers, LeadStatus, LeadActivity]
};

const SalesActivityPage = ({ notifications, objectId }) => (
  <PageWithConfigurator
    pageConfig={pageConfig}
    notifications={notifications}
    renderAI={() => <AIAgent pageName="sales_activity" widget objectId={objectId} />}
  />
);

export default SalesActivityPage;
